import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Box, colors, TextField, MenuItem, Modal, Fade, Typography, CircularProgress, Autocomplete, Input, Button } from '@mui/material';
import { EditSharp, CheckBoxOutlined, CheckBoxSharp, CheckBoxRounded, ThumbsUpDownSharp, ThumbUpSharp, GppGoodSharp, GppBadSharp, SearchSharp } from '@mui/icons-material';
import axios from 'axios';
import ReactDatePicker from 'react-datepicker';
import { format } from 'date-fns';
import Header from '../components/Header';
import Tabs from '../components/Tabs';
import 'react-datepicker/dist/react-datepicker.css';

import '../App.css'
import { useHistory, useLocation, useParams } from 'react-router-dom';

const CompanyVarianceEdit = () => {
	const history = useHistory();
	const { ticker, cik, date } = useParams()
	// console.log("ticker :::", ticker)
	const [currentUser, setCurrentUser] = useState(JSON.parse(localStorage.getItem('user')));
	const [dateRange, setDateRange] = useState([new Date(), new Date()]);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [financialUnitsList] = useState([
		{ text: "Actual Numbers", value: "W" },
		{ text: "Thousands", value: "K" },
		{ text: "Millions", value: "M" },
		{ text: "Billions", value: "B" },
		{ text: "Trillions", value: "T" },
	]);
	const [genderList] = useState([
		{ text: "Male", value: 'M' },
		{ text: "Female", value: 'F' },
		// { text: "Unknown", value: '' },
	]);
	const [selectedGender, setSelectedGender] = useState();
	const [sicGroups, setSicGoups] = useState([]);
	const [selectedSicGroup, setSelectedSicGoup] = useState([]);
	const [selectedCountry, setSelectedCountry] = useState();
	const [selectedCurrency, setSelectedCurrency] = useState('');
	const [searchTicker, setSearchTicker] = useState('');
	const [companies, setCompanies] = useState([]);
	const [people, setPeople] = useState([]);
	const [companyVarianceReference, setCompanyVarianceReference] = useState({
		company_name: "",
		company_friendly_name: "",
		company_alias: "",
		ticker: "",
		exchange_traded: "",
		type_of_filer: "",
		company_priority: "",
		cik: "",
		company_overiew: "",
		sic_id: "",
		sic_grp_code: "",
		sic_grp_name: "",
		phone_number: "",
		date_filed: "",
		form_group: "",
		bs_units: "",
		is_units: "",
		cf_units: "",
		currency: "",
		latest_revenue: "",
		latest_net_income: "",
		latest_eps: "",
		employees_count: "",
		website: "",
		ceo: "",
		sk_txn_sec_people_profile: "",
		gender: "",
		city: "",
		state: "",
		country: "",
		headquarters: "",
		omp: "",
		id: "",
		sk_txn_filing_overview: "",
		updated_by: "",
		updated_timestamp: "",
		priority: "",
		dataset: ""
	});
	const [companyVarianceEditable, setCompanyVarianceEditable] = useState({
		company_friendly_name: "",
		company_alias: "",
		ticker: "",
		exchange_traded: "",
		type_of_filer: "",
		cik: "",
		sic_id: "",
		sic_grp_code: "",
		sic_grp_name: "",
		date_filed: "",
		form_group: "",
		company_priority: "",
		company_overiew: "",
		bs_units: "",
		is_units: "",
		cf_units: "",
		latest_revenue: "",
		latest_net_income: "",
		latest_eps: "",
		employee_count: "",
		currency: "",
		website: "",
		ceo: "",
		sk_txn_sec_people_profile: "",
		gender: "",
		city: "",
		state: "",
		country: "",
		headquarters: "",
		phone_number: "",
		omp: "",
		id: "",
		sk_txn_filing_overview: "",
		updated_by: currentUser.first_name,
		updated_timestamp: new Date(),
		priority: "",
		dataset: ""
	});
	const [loading, setLoading] = useState(false);
	const [cardLoading, setCardLoading] = useState(false);
	const [countries, setCountries] = useState([]);
	const [currencies, setCurrencies] = useState([]);
	const [isFocused, setIsFocused] = useState(false);
	const [showDropdown, setShowDropdown] = useState(true);
	const [showPeopleDropdown, setPeopleShowDropdown] = useState(true);
	const [companySearchText, setCompanySearchText] = useState('');
	const [peopleSearchText, setPeopleSearchText] = useState('');
	const [selectedPeopleDetail, setSelectedPeopleDetail] = useState({});
	const companyInputRef = useRef();
	const peopleInputRef = useRef();


	const fetchVarianceDataByTicker = async () => {
		try {
			setCardLoading(true)
			// setIsModalOpen(true)
			setShowDropdown(false)

			await axios.get('/api/company-card/v2/variance/details/' + cik + '/' + date).then(resp => {
				console.log('company-card/v2/variance/details API RESP === ', resp.data.message.length, resp.data.message);
				setCompanyVarianceEditable(prev => ({ ...prev, ...resp.data.message[0] }));
				setSelectedSicGoup({
					sic_id: resp.data.message[0].sic_id || '',
					sic_name: resp.data.message[0].sic_name || '',
					sic_grp_code: resp.data.message[0].sic_group || '',
					sic_grp_name: resp.data.message[0].sic_group_desc || '',
				})
				setPeopleSearchText(resp.data.message[0].ceo)
				setSelectedCurrency(resp.data.message[0].currency)
				if (resp.data.message[1])
					setCompanyVarianceReference(prev => ({ ...prev, ...resp.data.message[1] }));
				setCardLoading(false);
			}).catch(error => {
				console.error(`Error From variance get details API - `, error);
				setCardLoading(false);
			});
		} catch (error) {
			console.error(`Error From variance get details API - `, error);
		}
	}

	useEffect(() => {
		fetchVarianceDataByTicker()
	}, [ticker, cik, date]);


	const closeModal = () => {
		history.goBack()
	};


	useEffect(() => {
		axios.get('/api/company-card/countries')
			.then(resp => {
				let c = resp.data.message.map(x => ({ country_name: x.country_name, country_code: x.country_code }))
				setCountries(c)
			}).catch(error => console.error('Error From Countries API - ', error));
	}, []);

	useEffect(() => {
		axios.get('/api/company-card/currencies')
			.then(resp => {
				let c = resp.data.message.map(x => x.currency_code)
				setCurrencies(c)
			}).catch(error => console.error('Error From Currencies API - ', error));
	}, []);

	useEffect(() => {
		axios.get('/api/company-card/master-sic-groups')
			.then(resp => setSicGoups(resp.data.message))
			.catch(error => console.error('Error From Sic Groups API - ', error));
	}, []);

	useEffect(() => {
		setCurrentUser(JSON.parse(localStorage.user));
	}, [dateRange[1], localStorage.user]);

	// const handleClose = () => {
	//   setIsModalOpen(false);
	// };

	const handleSicGroupChange = (e, value) => {
		console.log('Selected SIC GROUP OPTION = ', value);
		setSelectedSicGoup(value);
	};

	const handleCountryChange = (e, value) => {
		console.log('Selected Country OPTION = ', value);
		setSelectedCountry(value);
		setCompanyVarianceEditable(x => ({ ...x, country: value.country_name }));
	};

	const handleCurrencyChange = (e, value) => {
		console.log('Selected Currency OPTION = ', value);
		setSelectedCurrency(value);
		setCompanyVarianceEditable(x => ({ ...x, currency: value }));
	};

	const handleSubmission = (isCardApproved) => {
		console.log('Prepared Update Api Call Data :::::::::: ', { companyVarianceReference, companyVarianceEditable });
		setLoading(true);
		axios.put(`/api/company-card/v2/vairance`, {
			id: companyVarianceReference.id,
			cik: companyVarianceEditable.cik,
			company_friendly_name: companyVarianceEditable.company_friendly_name,
			company_alias: companyVarianceEditable.company_alias,
			ticker: companyVarianceEditable.ticker,
			type_of_filer: companyVarianceEditable.type_of_filer,
			company_overview: companyVarianceEditable.company_overiew,
			sic: selectedSicGroup.sic_id,
			sic_desc: selectedSicGroup.sic_name,
			sic_group: selectedSicGroup.sic_grp_code,
			sic_group_desc: selectedSicGroup.sic_grp_name,
			industry: selectedSicGroup.sic_grp_name,
			city: companyVarianceEditable.city,
			state: companyVarianceEditable.state,
			country: companyVarianceEditable.country,
			currency: companyVarianceEditable.currency,
			website: companyVarianceEditable.website,
			ceo: companyVarianceEditable.ceo,
			sk_txn_sec_people_profile: companyVarianceEditable.sk_txn_sec_people_profile,
			gender: companyVarianceEditable.gender,
			phone: companyVarianceEditable.phone_number,
			bs_units: companyVarianceEditable.bs_units,
			cf_units: companyVarianceEditable.cf_units,
			is_units: companyVarianceEditable.is_units,
			username: currentUser?.first_name,
			updated_by: companyVarianceEditable.updated_by,
			is_card_approved: isCardApproved,
			exchange_traded: companyVarianceEditable.exchange_traded,
			company_priority: companyVarianceEditable.company_priority,
			employees_count: companyVarianceEditable.employee_count,
			latest_revenue: companyVarianceEditable.latest_revenue,
			latest_net_income: companyVarianceEditable.latest_net_income,
			latest_eps: companyVarianceEditable.latest_eps,
			headquarters: companyVarianceEditable.headquarters
		}).then((response) => {
			alert(`Successfuly Updated Card Details!`, response.data.success);
			// document.location.reload();
			closeModal()

		}).catch(err => {
			console.error(`Failed To Update Card Details - `, err);
			alert(`Failed To Update Card Details:\n${err.response.data.message}`);
		});
	};


	let fetchCeoAbortController = null;
	const handleCeoChange = async (event) => {
		console.log("People Search Text === ", event.target.value)
		if (isFocused == true) setIsFocused(false);
		setPeople([]);
		setPeopleSearchText(event.target.value);
		// Cancel the previous fetch if it's still ongoing
		if (fetchCeoAbortController) {
			fetchCeoAbortController.abort();
		}

		// Create a new AbortController for the new fetch
		fetchCeoAbortController = new AbortController();
		const { signal } = fetchCeoAbortController;

		let searchKey = event.target.value.trim();
		if (searchKey.length >= 1) {
			console.log(`Calling People Search API === /api/people/v2/search?s=${searchKey}`)
			try {
				const response = await fetch(`/api/people/v2/search?s=${searchKey}`, { signal })
				if (response.ok) {
					const data = await response.json()
					if (!signal.aborted) {
						console.log('People Search API RESP === ', data.message);
						setPeople(data.message)
					}
				}
			} catch (error) {
				if (error.name !== 'AbortError') {
					console.error('Error While Fetching From People Search API - ', searchKey);
					console.error('Fetch failed:', error);
				}
			}
		}
	};



	return (
		<div>
			<Header />
			<Tabs />

			{/* <Fade in={isModalOpen}> */}
			{cardLoading
				? <div style={{ backgroundColor: '#FFF', border: '2px solid transparent', boxShadow: "5px 5px 5px solid #CCC", padding: 10, textAlign: 'center' }}>
					<CircularProgress color='secondary' />
				</div>
				: <div style={{ backgroundColor: '#FFF', border: '2px solid transparent', boxShadow: "5px 5px 5px solid #CCC", padding: 10 }}>
					<Box display="flex" flexDirection="row" justifyContent="space-between" px={3} py={1} fontWeight={500} bgcolor={colors.teal[50]} color={colors.blueGrey[700]} fontSize={18} id="CompanyVarience">
						<Typography variant='h6' fontWeight='bold' color={colors.blueGrey[700]} mr={10}>Edit Company CARD:&ensp;</Typography>
						<Typography variant='subtitle1' color={colors.purple[500]} mr={10}>
							<strong>SEC Conformed Name (as is from sec.gov):</strong>&emsp;{companyVarianceReference.company_confirmed_name}
						</Typography>
						<Typography variant='subtitle1' color={colors.purple[500]}>
							<strong>CIK:</strong>&emsp;{companyVarianceReference.cik}
						</Typography>
						<Typography variant='subtitle1' color={colors.purple[500]}>
							<strong>Dataset:</strong>&emsp;{companyVarianceReference.dataset}
						</Typography>
					</Box>
					{companyVarianceEditable
						? <>
							<Box display='flex' flexDirection='row' width='100%' justifyContent='center'>
								<Box border={1} borderColor={colors.blueGrey[300]} p={1} width='100%'>
									<Box display="flex" flexDirection="flex-start" justifyContent="flex-start">
										<Typography variant='subtitle1' color={colors.purple[500]} mr={10}>
											<strong>Current Filing:</strong>&emsp;
											<a target='_blank' href={`http://curatortool.com/omp/${companyVarianceEditable.omp}`}>{companyVarianceEditable.form_group} As On {new Date(companyVarianceEditable.date_filed).toDateString()}</a>
										</Typography>
										<Typography variant='subtitle1' color={colors.purple[500]}>
											<strong>Previous Filing:</strong>&emsp;
											<a target='_blank' href={`http://curatortool.com/omp/${companyVarianceReference.irk_fs_platter_omp}`}>{companyVarianceReference.form_group} As On {new Date(companyVarianceReference.date_filed).toDateString()}</a>
										</Typography>
									</Box>
									<hr />
									<Box display="flex" flexDirection="row" flexWrap='wrap' justifyContent="space-between" >
										<TextField
											required
											autoComplete='off'
											name="company_friendly_name"
											id="CompanyFriendlyName"
											label="Company Friendly Name"
											variant="outlined"
											value={companyVarianceEditable.company_friendly_name}
											// variant="standard"
											size='small'
											sx={{ width: 350, m: 2 }}
											InputLabelProps={{ shrink: true }}
											onChange={(e) => setCompanyVarianceEditable({ ...companyVarianceEditable, company_friendly_name: e.target.value })}
										/>
										<TextField
											autoComplete='off'
											name="company_alias"
											id="CompanyAlias"
											label="Company Alias"
											variant="outlined"
											value={companyVarianceEditable.company_alias}
											// variant="standard"
											size='small'
											sx={{ width: 180, m: 2 }}
											InputLabelProps={{ shrink: true }}
											onChange={(e) => setCompanyVarianceEditable({ ...companyVarianceEditable, company_alias: e.target.value })}
										/>
										<TextField
											required
											autoComplete='off'
											name="ticker"
											id="Ticker"
											label="Ticker"
											variant="outlined"
											value={companyVarianceEditable.ticker}
											// variant="standard"
											size='small'
											sx={{ width: 150, m: 2 }}
											InputLabelProps={{ shrink: true }}
											onChange={(e) => setCompanyVarianceEditable({ ...companyVarianceEditable, ticker: e.target.value })}
										/>
										<TextField
											autoComplete='off'
											name="exchange_traded"
											id="ExchangeTraded"
											label="Exchange Traded"
											variant="outlined"
											value={companyVarianceEditable.exchange_traded}
											// variant="standard"
											size='small'
											sx={{ width: 150, m: 2 }}
											InputLabelProps={{ shrink: true }}
											onChange={(e) => setCompanyVarianceEditable({ ...companyVarianceEditable, exchange_traded: e.target.value })}
										/>
										<TextField
											autoComplete='off'
											name="company_priority"
											id="CompanyPriority"
											label="Company Priority"
											variant="outlined"
											value={companyVarianceEditable.company_priority}
											// variant="standard"
											size='small'
											sx={{ width: 150, m: 2 }}
											InputLabelProps={{ shrink: true }}
											onChange={(e) => setCompanyVarianceEditable({ ...companyVarianceEditable, company_priority: e.target.value })}
										/>
										<TextField
											autoComplete='off'
											name="employees_count"
											id="EmployeesCount"
											label="No. Of Employees"
											variant="outlined"
											// variant="standard"
											type='number'
											value={companyVarianceEditable.employee_count || null}
											size='small'
											sx={{ width: 150, m: 2 }}
											InputLabelProps={{ shrink: true }}
											onChange={(e) => setCompanyVarianceEditable({ ...companyVarianceEditable, employee_count: e.target.value })}
										/>
										<TextField
											required
											autoComplete='off'
											name="company_overiew"
											id="CompanyOverview"
											label="Company Overview"
											multiline
											rows={3}
											variant="outlined"
											value={companyVarianceEditable.company_overiew}
											style={{ width: '100%', margin: '5px 10px' }}
											InputLabelProps={{ shrink: true }}
											onChange={(e) => setCompanyVarianceEditable({ ...companyVarianceEditable, company_overiew: e.target.value })}
										/>
										<Autocomplete
											disablePortal
											id="industry"
											options={sicGroups}
											groupBy={opt => opt.sic_grp_name}
											getOptionLabel={opt => `${opt.sic_grp_name} [${opt.sic_grp_code}] - ${opt.sic_name} [${opt.sic_id}]`}
											// getOptionLabel={opt => `${opt.sic_grp_name} [${opt.sic_grp_code}]`}
											sx={{ width: 700, m: 2 }}
											onChange={handleSicGroupChange}
											defaultValue={selectedSicGroup}
											value={selectedSicGroup}
											size='small'
											renderInput={(params) => <TextField {...params} label="Industry *" />}
										/>
										<TextField
											autoComplete='off'
											name="latest_revenue"
											id="LatestRevenue"
											label="Latest Revenue"
											variant="outlined"
											type='number'
											value={companyVarianceEditable.latest_revenue}
											// variant="standard"
											size='small'
											sx={{ width: 150, m: 2 }}
											InputLabelProps={{ shrink: true }}
											onChange={(e) => setCompanyVarianceEditable({ ...companyVarianceEditable, latest_revenue: e.target.value })}
										/>
										<TextField
											autoComplete='off'
											name="latest_net_income"
											id="LatestProfit"
											label="Latest Profit"
											variant="outlined"
											type='number'
											value={companyVarianceEditable.latest_net_income}
											// variant="standard"
											size='small'
											sx={{ width: 150, m: 2 }}
											InputLabelProps={{ shrink: true }}
											onChange={(e) => setCompanyVarianceEditable({ ...companyVarianceEditable, latest_net_income: e.target.value })}
										/>
										<TextField
											autoComplete='off'
											name="latest_eps"
											id="LatestEPS"
											label="Latest EPS"
											variant="outlined"
											type='number'
											value={companyVarianceEditable.latest_eps}
											// variant="standard"
											size='small'
											sx={{ width: 150, m: 2 }}
											InputLabelProps={{ shrink: true }}
											onChange={(e) => setCompanyVarianceEditable({ ...companyVarianceEditable, latest_eps: e.target.value })}
										/>
										<TextField
											required
											select
											name="bs_units"
											id="BSFinancialUnits"
											label="BS Financial Units"
											// value={companyVarience ? companyVarience.company_website : ''}
											value={companyVarianceEditable.bs_units}
											onChange={(e) => setCompanyVarianceEditable({ ...companyVarianceEditable, bs_units: e.target.value })}
											// variant="standard"
											size='small'
											sx={{ width: 180, m: 2 }}
											InputLabelProps={{ shrink: true }}
										>
											{financialUnitsList.map((fin) => (
												<MenuItem value={fin.value} selected={fin.value}>{fin.text}</MenuItem>
											))}
										</TextField>
										<TextField
											required
											select
											name="is_units"
											id="ISFinancialUnits"
											label="IS Financial Units"
											// value={companyVarience ? companyVarience.company_website : ''}
											value={companyVarianceEditable.is_units}
											onChange={(e) => setCompanyVarianceEditable({ ...companyVarianceEditable, is_units: e.target.value })}
											// variant="standard"
											size='small'
											sx={{ width: 180, m: 2 }}
											InputLabelProps={{ shrink: true }}
										>
											{financialUnitsList.map((fin) => (
												<MenuItem value={fin.value} selected={fin.value}>{fin.text}</MenuItem>
											))}
										</TextField>
										<TextField
											required
											select
											name="cf_units"
											id="CFFinancialUnits"
											label="CF Financial Units"
											// value={companyVarience ? companyVarience.company_website : ''}
											value={companyVarianceEditable.cf_units}
											onChange={(e) => setCompanyVarianceEditable({ ...companyVarianceEditable, cf_units: e.target.value })}
											// variant="standard"
											size='small'
											sx={{ width: 180, m: 2 }}
										>
											{financialUnitsList.map((fin) => (
												<MenuItem value={fin.value} selected={fin.value}>{fin.text}</MenuItem>
											))}
										</TextField>
										<Autocomplete
											disablePortal
											id="Country"
											options={countries}
											getOptionLabel={opt => opt.country_name}
											sx={{ width: 255, m: 2 }}
											onChange={handleCountryChange}
											defaultValue={selectedCountry}
											value={selectedCountry}
											size='small'
											renderInput={(params) => <TextField {...params} label="Country *" />}
										/>
										{/* <TextField
											required
											name="country"
											id="Country"
											label="Country"
											value={companyVarianceEditable.country}
											onChange={(e) => setCompanyVarianceEditable({ ...companyVarianceEditable, country: e.target.value })}
											// variant="standard"
											size='small'
											sx={{ width: 180, m: 2 }}
											InputLabelProps={{ shrink: true }}
										/> */}
										<TextField
											required
											name="State"
											id="State"
											label="State"
											value={companyVarianceEditable.state}
											onChange={(e) => setCompanyVarianceEditable({ ...companyVarianceEditable, state: e.target.value })}
											// variant="standard"
											size='small'
											sx={{ width: 180, m: 2 }}
											InputLabelProps={{ shrink: true }}
										/>
										<TextField
											required
											name="city"
											id="City"
											label="City"
											value={companyVarianceEditable.city}
											onChange={(e) => setCompanyVarianceEditable({ ...companyVarianceEditable, city: e.target.value })}
											// variant="standard"
											size='small'
											sx={{ width: 180, m: 2 }}
											InputLabelProps={{ shrink: true }}
										/>
										<TextField
											required
											name="headquarters"
											id="Headquarters"
											label="Headquarters"
											value={companyVarianceEditable.headquarters}
											onChange={(e) => setCompanyVarianceEditable({ ...companyVarianceEditable, headquarters: e.target.value })}
											// variant="standard"
											size='small'
											sx={{ width: 130, m: 2 }}
											InputLabelProps={{ shrink: true }}
										/>
										<Autocomplete
											disablePortal
											id="Currency"
											size='small'
											sx={{ width: 120, m: 2 }}
											options={currencies}
											getOptionLabel={opt => opt}
											defaultValue={selectedCurrency}
											value={selectedCurrency}
											onChange={handleCurrencyChange}
											renderInput={(params) => <TextField {...params} label="Currency *" />}
										/>
										{/* <TextField
                                                    required
                                                    name="currency"
                                                    id="currency"
                                                    label="Currency Used"
                                                    value={companyVarianceEditable.currency}
                                                    onChange={(e) => setCompanyVarianceEditable({ ...companyVarianceEditable, currency: e.target.value })}
                                                    // variant="standard"
                                                    size='small'
                                                    sx={{ width: 130, m: 2 }}
                                                    InputLabelProps={{ shrink: true }}
                                                    helperText='(ISO Code)'
                                                /> */}
										<TextField
											required
											name="website"
											id="Website"
											label="Website"
											value={companyVarianceEditable.website}
											onChange={(e) => setCompanyVarianceEditable({ ...companyVarianceEditable, website: e.target.value })}
											// variant="standard"
											size='small'
											sx={{ width: 250, m: 2 }}
											InputLabelProps={{ shrink: true }}
											helperText='Do not include http(s)://'
										/>
										<TextField
											required
											name="phone_number"
											id="Phone"
											label="Phone Number"
											// value={companyVarience ? companyVarience.company_website : ''}
											value={companyVarianceEditable.phone_number}
											onChange={(e) => setCompanyVarianceEditable({ ...companyVarianceEditable, phone_number: e.target.value })}
											// variant="standard"
											size='small'
											sx={{ width: 180, m: 2 }}
											InputLabelProps={{ shrink: true }}
										/>
										<div className="input-field" style={{ position: 'relative' }}>
											<TextField
												required
												type="text"
												autoComplete='off'
												className="form-control"
												name="ceo"
												placeholder="Search People"
												label="Company CEO"
												value={peopleSearchText}
												onChange={(e) => handleCeoChange(e)}
												onFocus={() => setPeopleShowDropdown(true)}
												onBlur={() => setTimeout(() => setPeopleShowDropdown(false), 200)}
											/>
											{showPeopleDropdown && people.length > 0 &&
												<ul style={{ position: 'absolute', listStyle: 'none', top: 55, left: -2, width: "max-content", display: "flex", flexDirection: 'column', justifyContent: "flex-start", alignItems: "start", background: '#fff', border: "1px solid #CCC", borderRadius: 5, zIndex: 9, padding: "0px", boxShadow: "5px 5px 10px #00000025" }}>
													{people?.map(person =>
														<li
															id="c-dropdown"
															key={person.id}
															style={{ cursor: 'pointer', padding: "7px 5px", margin: "2px", fontSize: '0.85rem' }}
															onClick={() => { console.log('Selected CEO = ', person); setSelectedPeopleDetail(person); setCompanyVarianceEditable({ ...companyVarianceEditable, ceo: person.name, sk_txn_sec_people_profile: person.id }); setPeopleSearchText(person.name) }}
														>{person.name}&ensp;({person.id})&ensp;<span style={{ fontWeight: 500, color: 'blue' }}>[{person.known_for}]</span>
														</li>
													)}
												</ul>}
										</div>
										{/* <TextField
                                                    required
                                                    name="ceo"
                                                    id="Ceo"
                                                    label="Company CEO"
                                                    value={companyVarianceEditable.ceo}
                                                    onChange={(e) => setCompanyVarianceEditable({ ...companyVarianceEditable, ceo: e.target.value })}
                                                    // variant="standard"
                                                    size='small'
                                                    sx={{ width: 180, m: 2 }}
                                                    InputLabelProps={{ shrink: true }}
                                                /> */}
										<TextField
											required
											select
											name="gender"
											id="Gender"
											label="CEO Gender"
											value={companyVarianceEditable.gender}
											onChange={(e) => setCompanyVarianceEditable({ ...companyVarianceEditable, gender: e.target.value })}
											// variant="standard"
											size='small'
											sx={{ width: 100, m: 2 }}
											InputLabelProps={{ shrink: true }}
										>
											{genderList.map((fin) => (
												<MenuItem value={fin.value} selected={fin.value}>{fin.text}</MenuItem>
											))}
										</TextField>
										<TextField
											required
											select
											name="type_of_filer"
											id="FilerType"
											label="Type Of Filer"
											value={companyVarianceEditable.type_of_filer}
											onChange={(e) => setCompanyVarianceEditable({ ...companyVarianceEditable, type_of_filer: e.target.value })}
											// variant="standard"
											size='small'
											sx={{ width: 150, m: 2 }}
											InputLabelProps={{ shrink: true }}
										>
											<MenuItem value={'accelerated'} selected={companyVarianceEditable.type_of_filer}>accelerated</MenuItem>
											<MenuItem value={'smaller'} selected={companyVarianceEditable.type_of_filer}>smaller</MenuItem>
											<MenuItem value={'emerging'} selected={companyVarianceEditable.type_of_filer}>emerging</MenuItem>
										</TextField>
									</Box>
									<Box display='flex' justifyContent='flex-start' gap={18} mx={2}>
										<Typography variant='subtitle1' color={colors.purple[500]}>
											<strong>Last Updated By:</strong>&ensp;{companyVarianceEditable?.updated_by}
										</Typography>
										<Typography variant='subtitle1' color={colors.purple[500]}>
											<strong>Last Updated On:</strong>&ensp;
											{companyVarianceEditable?.updated_timestamp ? new Date(companyVarianceEditable.updated_timestamp).toUTCString() : ""}
										</Typography>
									</Box>
								</Box>
							</Box>
							<Box display='flex' justifyContent='flex-end' mt={1} mx={1}>
								<input
									type="submit"
									onClick={(e) => handleSubmission(true)}
									className="btn btn-success"
									value="Approve & Save"
									style={{ backgroundColor: colors.green[100], color: colors.green[900], fontWeight: 600, letterSpacing: 0.5, marginRight: '20px', border: `1px solid ${colors.green[900]}`, width: '9rem', height: '2rem', cursor: "pointer" }}
								/>
								<input
									type="submit"
									onClick={(e) => handleSubmission(false)}
									className="btn btn-success"
									value="Save As Draft"
									style={{ backgroundColor: colors.lightBlue[100], color: colors.lightBlue[900], fontWeight: 600, letterSpacing: 0.5, marginRight: '20px', border: `1px solid ${colors.lightBlue[900]}`, width: '9rem', height: '2rem', cursor: "pointer" }}
								/>
								<input
									type="submit"
									onClick={(e) => closeModal()}
									className="btn btn-secondary"
									value="Cancel"
									style={{ backgroundColor: colors.blueGrey[100], color: colors.blueGrey[900], fontWeight: 600, letterSpacing: 0.5, border: `1px solid ${colors.blueGrey[900]}`, width: '9rem', height: '2rem', cursor: "pointer" }}
								/>
							</Box>
						</>
						: <Box display='flex' justifyContent='space-between' mt={1} mx={1}>
							<h3 className='error'>No Variance Data Found For The Selected Company</h3>
							<input
								type="submit"
								onClick={(e) => closeModal()}
								className="btn btn-sm btn-secondary"
								value="Close"
								style={{ backgroundColor: colors.blueGrey[100], color: colors.blueGrey[900], fontWeight: 600, letterSpacing: 0.5, border: `1px solid ${colors.blueGrey[900]}`, width: '9rem', height: '2rem', cursor: "pointer" }}
							/>
						</Box>}
				</div>}
			{/* </Fade> */}
		</div >
	);
};

export default CompanyVarianceEdit;
